export default "__VITE_ASSET__H$fVL1E___"